export default __webpack_public_path__ + "static/media/hashnode.6d18a098.png";